import MainInformations from "../mainInformation";

const styles = {
  extratsMainContainer: {
    display: "flex",
    flexDirection: "column",
  },
  conatainer: {
    display: "flex",
  },
  iconButton: {
    height: "42px",
  },
  mainInformations: {
    display: "flex",
    flexDirection: "column",
  },
  subMain: {
    display: "flex",
    flexDirection: "row",
  },
};

export default styles;
